<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;My Independence Declaration</h5>
  </div>

<div class="container">
  <div class="modal-body">
    <div class="row">
    <div class="col-md-6">
      <div class="card shadow">
        <div class="card-body align-items-start">
          <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="PostAssignClick()">
            My Post Assignment Declaration
          </div>
      </div>
      </div>
    </div>

    <div class="col-md-6">
        <div class="card shadow">
          <div class="card-body align-items-start">
            <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="clientDeclaClick()">
              My New Client Declaration
            </div>
        </div>
        </div>
    </div>
  </div>

  <div class="row pt-4">
    <div class="col-md-6">
      <div class="card shadow">
        <div class="card-body align-items-start">
          <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="employeeJoinClick()">
            My Employee Joining Declaration
          </div>
      </div>
      </div>
  </div>

    <div class="col-md-6">
      <div class="card shadow">
        <div class="card-body align-items-start">
          <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="annualDeclaClick()">
            My Annual Declaration
          </div>
      </div>
      </div>
  </div>
  </div>
  <div class="row pt-4">
    <div class="col-md-6">
      <div class="card shadow">
        <div class="card-body align-items-start">
          <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="dpdpDeclarationClick()">
            My DPDP Declaration
          </div>
      </div>
      </div>
  </div>
  </div>
  </div>
</div>
</div>
